import TemplateView from "../../../TemplateView"
import PermissionIcons from "../PermissionIcons"
import {getInstance as assignmentsTooltip} from '../../../SimpleSingletonTooltip'

export default class UserItem extends TemplateView {
    constructor({
        title = "",
        subtitle = "",
        deleteButtonVisible = false,
        deleteButtonDisabled = false,
        onDeleteClick = () => {},
        showPermissionIcons = false,
        manageUsers = false,
        modifyTimeTrack = false,
        manageScope = false,
        costReports = false,
        showCostReports = false,
        costReportsTooltipText = "",
        modifyTimeTrackTooltipText = '',
        deleteButtonDisabledTooltipText = "",
    }) {
        super();

        this.title = title;
        this.subtitle = subtitle;
        this.deleteButtonVisible = deleteButtonVisible;
        this.deleteButtonDisabled = deleteButtonDisabled;
        this.deleteButtonDisabledTooltipText = deleteButtonDisabledTooltipText
        this.onDeleteClick = onDeleteClick;
        if (showPermissionIcons) {
            this.permissionIcons = new PermissionIcons({
                manageUsers,
                modifyTimeTrack,
                manageScope,
                costReports,
                showCostReports,
                costReportsTooltipText,
                modifyTimeTrackTooltipText
            })
        }
    }

    templateHtml() {
        return "<div class='item withDeleteButton'>" +
               "  <div class='itemContent'>" +
               "    <div class='title'><%-title%></div>" +
               "    <div class='optionalContent'>" +
               "        <div class='subtitle'><%-subtitle%></div>" +
               "        <div class='permissionIconsContainer'></div>" +
               "        <div class='deleteButton'>" +
               "           <div class='deleteIcon'></div>" +
               "        </div>" +
               "    </div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        const $deleteButton = this.find(".deleteButton")
        if (this.deleteButtonVisible && !this.deleteButtonDisabled) {
            $deleteButton.click(() => this.onDeleteClick());
        }

        if (this.permissionIcons) {
            this.permissionIcons.init(this.find(".permissionIconsContainer"))
        }

        this.$el.toggleClass("deleteButtonVisible", this.deleteButtonVisible);
        this.$el.toggleClass("deleteButtonDisabled", this.deleteButtonDisabled);
        this.$el.toggleClass("withSubtitle", !!this.subtitle);
        this.$el.toggleClass("withPermissionIcons", !!this.permissionIcons);

        if (this.deleteButtonVisible && this.deleteButtonDisabled && this.deleteButtonDisabledTooltipText) {
            assignmentsTooltip().subscribeToMouseEvents($deleteButton, () => {
                assignmentsTooltip().setState({
                    text: this.deleteButtonDisabledTooltipText,
                    extraClass: 'hierarchyAssignmentsTooltip',
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/usersList/UserItem.js